import { useLocation } from "react-router-dom";
import { modules } from "@/modules";
import type { AdminModule } from "@/modules/types";

/**
 * The module owning the current path, or null on /overview's siblings.
 *
 * Longest key first so `/feature-flags` is not claimed by a hypothetical
 * `/feature` module, and so a future nested key cannot be shadowed by its
 * prefix.
 */
export function useCurrentModule(): AdminModule | null {
  const { pathname } = useLocation();
  const sorted = [...modules].sort((a, b) => b.key.length - a.key.length);
  return (
    sorted.find((m) => pathname === `/${m.key}` || pathname.startsWith(`/${m.key}/`)) ?? null
  );
}
